import { Box, Typography } from "@mui/material";
import React from "react";
import { getHideSelfView } from "../../../../base/settings/functions.any";
import { useDispatch, useSelector } from "react-redux";
import { updateSettings } from "../../../../base/settings/actions";
import Icon from "../../../../base/icons/components/Icon";
import { IconCheck } from "../../../../base/icons/svg";
import { useTranslation } from "react-i18next";
const HideScreen = ({ classes, cx, handleClose }) => {
    const disableSelfView = useSelector((state) => getHideSelfView(state));
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const handleClick = () => {
        dispatch(updateSettings({
            disableSelfView: !disableSelfView
        }));
        handleClose();
    };
    return (React.createElement(Box, { className: classes.borderTop },
        React.createElement(Box, { className: cx(classes.itemPopover, disableSelfView ? `${classes.choosen}` : ''), onClick: handleClick },
            React.createElement(Box, { sx: {
                    marginRight: '10px',
                    '& svg': {
                        height: '22px',
                        width: '22px'
                    }
                } },
                React.createElement(Icon, { size: 24, src: IconCheck, color: disableSelfView ? 'white' : 'transparent' })),
            React.createElement(Typography, { className: classes.textItem, sx: { marginLeft: '0px !important' } }, t('dialog.layout.hideMyScreen')))));
};
export default HideScreen;
